import React from 'react';
import './Loader.css';

interface LoaderProps {
    size?: number;
    text?: string;
    style?: React.CSSProperties;
}

const Loader: React.FC<LoaderProps> = ({ size = 48, text = 'Cargando...', style }) => (
    <div className='ciclii-loader-container' style={style}>
        <div
            className='ciclii-loader-spinner'
            style={{ width: size, height: size, borderWidth: size / 8 }}
        />
        {text && <div className='ciclii-loader-text'>{text}</div>}
    </div>
);

export default Loader;
